<footer class="footer">
  <div class="container">
    <mat-divider></mat-divider>
    <div class="d-flex w-100 h-100 flex-wrap">
      <div class="footer-left flex-wrap">
        <div class="footer-logo">
          <bdg-label type="subheading-1">SIGRESIDÊNCIAS</bdg-label>
          <div>
            <img src="assets/images/logo-sig-small.svg" alt="Logo SIGRESIDÊNCIAS" />
            <bdg-label class="ml-2" type="caption">Versão {{ projectVersion }}</bdg-label>
          </div>
        </div>
        <div>
          <a href="api/public/arquivos-sistema/manual/download" target="_blank" rel="noopener noreferrer">
            <bdg-label type="body-1">Manual</bdg-label>
          </a>

          <a href="api/public/arquivos-sistema/faq/download" target="_blank" rel="noopener noreferrer">
            <bdg-label type="body-1">Perguntas frequentes</bdg-label>
          </a>

          <bdg-label type="body-1">
            <a href="mailto:residencias@saude.gov.br" target="_blank" rel="noopener noreferrer"
              >residencias@saude.gov.br</a
            >
          </bdg-label>

          <bdg-label type="body-1">
            <a href="/termos">Termos de uso </a>
          </bdg-label>

          <bdg-label type="body-1">
            <a [routerLink]="" (click)="onClick()" style="cursor: pointer">Modelos de arquivos institucionais </a>
          </bdg-label>
        </div>
      </div>
      <a
        class="footer-right"
        href="https://saude.gov.br/"
        target="_blank"
        rel="noopener noreferrer"
        style="margin-top: 1.3rem"
      >
        <img src="assets/images/ms2.png" alt="Ministério da Saúde" />
      </a>
    </div>
  </div>
</footer>
